var _circle, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParentPageSect2Icon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D5D2FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 6,
    fill: "#22C55E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7099 27.2919C41.617 27.1982 41.5064 27.1238 41.3845 27.073C41.2627 27.0222 41.132 26.9961 40.9999 26.9961C40.8679 26.9961 40.7372 27.0222 40.6154 27.073C40.4935 27.1238 40.3829 27.1982 40.2899 27.2919L33.9999 33.5919L29.7099 29.2919C29.617 29.1982 29.5064 29.1238 29.3845 29.073C29.2627 29.0222 29.132 28.9961 28.9999 28.9961C28.8679 28.9961 28.7372 29.0222 28.6154 29.073C28.4935 29.1238 28.3829 29.1982 28.2899 29.2919L22.2899 35.2919C22.1962 35.3849 22.1218 35.4955 22.071 35.6173C22.0203 35.7392 21.9941 35.8699 21.9941 36.0019C21.9941 36.1339 22.0203 36.2646 22.071 36.3865C22.1218 36.5083 22.1962 36.6189 22.2899 36.7119C22.3829 36.8056 22.4935 36.88 22.6154 36.9308C22.7372 36.9816 22.8679 37.0077 22.9999 37.0077C23.132 37.0077 23.2627 36.9816 23.3845 36.9308C23.5064 36.88 23.617 36.8056 23.7099 36.7119L28.9999 31.4119L33.2899 35.7119C33.3829 35.8056 33.4935 35.88 33.6154 35.9308C33.7372 35.9816 33.8679 36.0077 33.9999 36.0077C34.132 36.0077 34.2627 35.9816 34.3845 35.9308C34.5064 35.88 34.617 35.8056 34.7099 35.7119L41.7099 28.7119C41.8037 28.6189 41.8781 28.5083 41.9288 28.3865C41.9796 28.2646 42.0057 28.1339 42.0057 28.0019C42.0057 27.8699 41.9796 27.7392 41.9288 27.6173C41.8781 27.4955 41.8037 27.3849 41.7099 27.2919Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentPageSect2Icon2);
export default __webpack_public_path__ + "static/media/parentPage-sect2-icon2.59a4843dd1572fc1b01c8bf78a1136d3.svg";
export { ForwardRef as ReactComponent };